// extracted by mini-css-extract-plugin
module.exports = {"alGhadeerTitle":"style_alGhadeerTitle__AvBHT"};